import { getDefaultLogonEmailAddress, getDefaultUserEmailAddress } from 'owa-session-store';

import type MailboxInfo from '../schema/MailboxInfo';
import type MailboxType from '../schema/MailboxType';
import getStore from '../store';

// Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
// -> Error TS7034 (10,5): Variable 'altGetUserMailboxInfo' implicitly has type 'any' in some locations where its type cannot be determined.
// @ts-expect-error
let altGetUserMailboxInfo = undefined;

/**
 * REFLOW TECHNICAL DEBT
 *
 * When we ge to the Respond approach for multi-account the getUserMailboxInfo will be removed and all
 * mailboxes will be gotten via a sourceId. In order to support the Reflow approach we need to have the
 * getUserMailboxInfo to return the mailbox based on the currently selected account.
 *
 * We cannot directly import owa-account-source-list because it needs to import the owa-client-ids to
 * get the MailboxInfo type, and importing owa-account-source-list here would create a circular dependency.
 * One way to fix this would be to move the MailboxInfo into another package, however since the
 * getUserMailboxInfo will be removed when the Respond approach is implemented the decision is to
 * break the circular dependency by setting the method that will get the MailboxInfo using the selected account.
 *
 * @param userIdentity identifies the mailbox, when not specified the selected mailbox is assumed
 * @returns The mailbox that should be used for the identity
 */
export function setAltGetUserMailboxInfo(
    callback: (userIdentity?: string | null) => MailboxInfo | undefined
) {
    altGetUserMailboxInfo = callback;
}

/**
Gets the mailboxInfo object for given userIdentity.
This also adds to the map of mailboxInfos keyed on userIdentity passed in.
The Map only holds userMailbox type info's (and not group mailbox info's)
and hence the userIdentity and mailboxSmtpAddress are both assigned the same userIdentity value in case of connected account
@param userIdentity userIdentity of the userMailbox required. If not passed, we assume default user
@param bypassAlt when true the altGetUserMailboxInfo will be bypassed if set
 */
export default function getUserMailboxInfo(
    userIdentity?: string | null,
    bypassAlt?: boolean
): MailboxInfo {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS7005 (49,9): Variable 'altGetUserMailboxInfo' implicitly has an 'any' type.
    // @ts-expect-error
    if (altGetUserMailboxInfo && !bypassAlt) {
        // If the altGetUserMailboxInfo callback is set use it to try and get the mailbox
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2349 (54,32): This expression is not callable.
        // @ts-expect-error
        const altMailboxInfo = altGetUserMailboxInfo(userIdentity);
        if (altMailboxInfo) {
            return altMailboxInfo;
        }
    }

    const userMailboxInfoMap = getStore().userMailboxInfoMap;
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (64,56): Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
    // @ts-expect-error
    if (!userMailboxInfoMap || !userMailboxInfoMap.get(userIdentity)) {
        let isConnectedAccount: Boolean = false;
        if (userIdentity) {
            isConnectedAccount = userIdentity == getDefaultLogonEmailAddress() ? false : true;
        }
        let userMailboxInfo = {
            type: 'UserMailbox' as MailboxType,
            userIdentity: isConnectedAccount ? userIdentity : getDefaultLogonEmailAddress(),
            mailboxSmtpAddress: isConnectedAccount ? userIdentity : getDefaultUserEmailAddress(),
        };

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (78,32): Argument of type 'string | null | undefined' is not assignable to parameter of type 'string'.
        // @ts-expect-error
        userMailboxInfoMap.set(userIdentity, userMailboxInfo);

        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (83,9): Type '{ type: MailboxType; userIdentity: string | null | undefined; mailboxSmtpAddress: string | null | undefined; }' is not assignable to type 'MailboxInfo'.
        // @ts-expect-error
        return userMailboxInfo;
    }

    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2322 (89,5): Type 'MailboxInfo | undefined' is not assignable to type 'MailboxInfo'.
    // @ts-expect-error
    return userMailboxInfoMap.get(userIdentity);
}
